import { useSearchParams } from 'react-router-dom'
import Page from '../../Components/Page'
import './SuccessPage.less'
import '../../Styles/buttons.less'
import useBriefContext from '../../Hooks/Brief/useBriefContext'
import { useEffect } from 'react'
import BusinessSuccessPage from './Business/SuccessPage'
import { LeadFeedSuccessPage, SuccessHeader } from './LeadFeed/LeadFeedSuccess'
import SuccessCopy from './EndScreenMessage'

const SuccessPage = (): JSX.Element => {
  const { setShowBizLayout, brief } = useBriefContext()
  const [searchParams] = useSearchParams()
  const briefType = searchParams.get('type')
  const venueName = searchParams.get('venue-name')
  const businessEventUUID = searchParams.get('business-event-uuid')
  const directEnquiry = briefType === 'enquiry'

  useEffect(() => {
    setShowBizLayout(true) // hide LF messaging
  }, [])

  if (briefType === 'business') {
    return businessEventUUID ? (
      <BusinessSuccessPage businessEventUUID={businessEventUUID} />
    ) : (
      <Page
        heading='Brilliant! Enquiry submitted.'
        metaTitle='All done! - HeadBox'
        className='success-page fade-in'>
        <SuccessCopy messageKey='au-biz' />
      </Page>
    )
  }

  return (
    <Page
      metaTitle='All done! - HeadBox'
      className='success-page fade-in'
      header={<SuccessHeader guestEmail={brief?.guest?.email} />}>
      <LeadFeedSuccessPage directEnquiry={directEnquiry} directEnquiryVenueName={venueName} />
    </Page>
  )
}

export default SuccessPage
